import { useLayoutEffect } from "react";

export function useLockBodyScroll(active, positionY = 0, submenuClick = false) {
  useLayoutEffect(() => {
    const originalOverflow = window.getComputedStyle(document.body).overflow;
    const originalPosition = window.getComputedStyle(document.body).position;
    const pageElement = window.document.getElementById("page");
    const homeElement = window.document.getElementById("home");
    const footerElement = window.document.getElementById("footer");

    const showHideBackground = value => {
      if (homeElement) homeElement.style.opacity = value;
      if (pageElement) pageElement.style.opacity = value;
      footerElement.style.opacity = value;
    };

    if (active) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      showHideBackground(0);
      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.position = originalPosition;
        showHideBackground(1);
        window.scrollTo(0, submenuClick ? 0 : positionY);
      };
    }
  }, [active, submenuClick]);
}
